export enum UserType {
  INTERNAL = 'internal',
  WAZZUP = 'wazzup',
}

export interface User {
  id: string;
  fancyId: string;
  email: string | null;
  phoneNumber: string | null;
  userType: UserType;
}
